'use client';
import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import styles from './schemes-page.module.css';

export default function SchemesClient({ categories, initialPosts, initialCategoryId }: any) {
    const [activeCategory, setActiveCategory] = useState(initialCategoryId);
    const [posts, setPosts] = useState(initialPosts);
    const [loading, setLoading] = useState(false);

    const handleCategoryChange = async (categoryId: number) => {
        if (categoryId === activeCategory) return;
        setLoading(true);
        setActiveCategory(categoryId);

        try {
            const res = await fetch(`/api/schemes?categories=${categoryId}&per_page=100`);

            if (!res.ok) {
                throw new Error(`Failed to fetch posts: ${res.status}`);
            }

            const newPosts = await res.json();
            setPosts(newPosts);
        } catch (error) {
            console.error('Error fetching posts:', error);
            setPosts([]);
        } finally {
            setLoading(false);
            if (window.innerWidth < 780) {
                document.getElementById('category-title')?.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    const categoryName = categories.find((cat: any) => cat.id === activeCategory)?.name || 'Uncategorized';

    return (
        <>
            <div className={`${styles.categoriesList} md:sticky md:top-5 md:h-fit`}>
                <ul>
                    {categories.map((category: any) => (
                        <li key={category.id}>

                            <a href="#posts-container"
                                className={`${styles.categoryLink} ${activeCategory === category.id ? styles.activeCategoryLink : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleCategoryChange(category.id);
                                }}
                            >
                                {category.name} ({category.count})
                            </a>
                        </li>
                    ))}
                </ul>
            </div >

            <div className={styles.postsList}>
                <h2 id="category-title">{categoryName}</h2>
                <div id="posts-container" className={`${styles.contentContainer} ${loading ? styles.blur : ''}`}>
                    {posts.length > 0 ? (
                        posts.map((post: any) => (
                            <div key={post.id} className={styles.postCard}>
                                {post.acf?.izobrazhenie && (
                                    <div className={styles.postCardImage}>
                                        <Image
                                            src={post.acf.izobrazhenie}
                                            alt={post.acf.zagolovok || 'Scheme image'}
                                            width={300}
                                            height={200}
                                            className="object-cover"
                                        />
                                    </div>
                                )}
                                <div className={styles.entryHeader}>
                                    <h2 className={styles.entryTitle}>
                                        <Link href={`/schemes/${post.slug}`}>
                                            {post.acf?.zagolovok || post.title?.rendered}
                                        </Link>
                                    </h2>
                                    {post.acf?.podzagolovok && (
                                        <div className={styles.shortDesc}>{post.acf.podzagolovok}</div>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>Нет постов для этой категории</p>
                    )}
                </div>
                {loading && (
                    <div className={`${styles.loaderContainer} ${styles.visible}`}>
                        <div className={styles.loader}></div>
                    </div>
                )}
            </div>
        </>
    );
}